{
  "schemaVersion": 1,
  "generatedAt": "2026-07-28T16:24:40.785Z",
  "entries": {
    "KRX:000660": {
      "instrumentId": "KRX:000660",
      "ticker": "000660",
      "entityName": "SK hynix Inc.",
      "relationship": "issuer",
      "relationshipNote": null,
      "providerSymbol": "File:SK Hynix.svg",
      "asset": {
        "path": "/company-logos/KRX_000660.f906550fb533bf1d.svg",
        "mimeType": "image/svg+xml",
        "byteSize": 9765,
        "hash": {
          "algorithm": "sha256",
          "value": "f906550fb533bf1d20ba73fdffdab2a210eb679577cde146247abbfdf62a78ee"
        }
      },
      "source": {
        "provider": "wikimedia"
      },
      "license": {
        "status": "reviewed",
        "name": "Public domain"
      },
      "fetchedAt": "2026-07-28T16:06:59.857Z",
      "cachePolicy": {
        "mode": "vendored",
        "revalidateAfterDays": 30
      }
    },
    "KRX:003490": {
      "instrumentId": "KRX:003490",
      "ticker": "003490",
      "entityName": "Korean Air Lines Co., Ltd.",
      "relationship": "issuer",
      "relationshipNote": null,
      "providerSymbol": "File:Korean Air 2025.svg",
      "asset": {
        "path": "/company-logos/KRX_003490.1f6d4689232d0d4c.svg",
        "mimeType": "image/svg+xml",
        "byteSize": 4251,
        "hash": {
          "algorithm": "sha256",
          "value": "1f6d4689232d0d4c216ddbc4d45a76c672cee8b239fb284eb42e07b1424c618d"
        }
      },
      "source": {
        "provider": "wikimedia"
      },
      "license": {
        "status": "reviewed",
        "name": "Public domain"
      },
      "fetchedAt": "2026-07-28T16:22:57.269Z",
      "cachePolicy": {
        "mode": "vendored",
        "revalidateAfterDays": 30
      }
    },
    "KRX:005490": {
      "instrumentId": "KRX:005490",
      "ticker": "005490",
      "entityName": "POSCO Holdings Inc.",
      "relationship": "other",
      "relationshipNote": "POSCO Holdings가 사용하는 POSCO 그룹 브랜드 표식입니다.",
      "providerSymbol": "File:POSCO logo.svg",
      "asset": {
        "path": "/company-logos/KRX_005490.92ad877883326caf.svg",
        "mimeType": "image/svg+xml",
        "byteSize": 4051,
        "hash": {
          "algorithm": "sha256",
          "value": "92ad877883326caf9a8ce60b28a6e47b4151ff14fa8ae8332e13c5f3667a625f"
        }
      },
      "source": {
        "provider": "wikimedia"
      },
      "license": {
        "status": "reviewed",
        "name": "Public domain"
      },
      "fetchedAt": "2026-07-28T16:07:36.945Z",
      "cachePolicy": {
        "mode": "vendored",
        "revalidateAfterDays": 30
      }
    },
    "KRX:006400": {
      "instrumentId": "KRX:006400",
      "ticker": "006400",
      "entityName": "Samsung SDI Co., Ltd.",
      "relationship": "issuer",
      "relationshipNote": null,
      "providerSymbol": "File:Samsung SDI logo (english).svg",
      "asset": {
        "path": "/company-logos/KRX_006400.41599d0ff18a13bc.svg",
        "mimeType": "image/svg+xml",
        "byteSize": 6215,
        "hash": {
          "algorithm": "sha256",
          "value": "41599d0ff18a13bc2db2db3e6a8c1417e0620e12556eda71ea8a27c076543c86"
        }
      },
      "source": {
        "provider": "wikimedia"
      },
      "license": {
        "status": "reviewed",
        "name": "Public domain"
      },
      "fetchedAt": "2026-07-28T16:22:41.328Z",
      "cachePolicy": {
        "mode": "vendored",
        "revalidateAfterDays": 30
      }
    },
    "KRX:011200": {
      "instrumentId": "KRX:011200",
      "ticker": "011200",
      "entityName": "HMM Co., Ltd.",
      "relationship": "issuer",
      "relationshipNote": null,
      "providerSymbol": "File:HMM Logo Basic Form.svg",
      "asset": {
        "path": "/company-logos/KRX_011200.75c4a5ff17895eb5.svg",
        "mimeType": "image/svg+xml",
        "byteSize": 1928,
        "hash": {
          "algorithm": "sha256",
          "value": "75c4a5ff17895eb55686f3fd73bd4eebc0fd659c43f6bc1299ecf5c2bb9ec582"
        }
      },
      "source": {
        "provider": "wikimedia"
      },
      "license": {
        "status": "reviewed",
        "name": "Public domain"
      },
      "fetchedAt": "2026-07-28T16:22:33.412Z",
      "cachePolicy": {
        "mode": "vendored",
        "revalidateAfterDays": 30
      }
    },
    "KRX:012330": {
      "instrumentId": "KRX:012330",
      "ticker": "012330",
      "entityName": "Hyundai Mobis Co., Ltd.",
      "relationship": "issuer",
      "relationshipNote": null,
      "providerSymbol": "File:Hyundai Mobis Logo.svg",
      "asset": {
        "path": "/company-logos/KRX_012330.1f0f11c2ca7895da.svg",
        "mimeType": "image/svg+xml",
        "byteSize": 6050,
        "hash": {
          "algorithm": "sha256",
          "value": "1f0f11c2ca7895da7acf3f5e5c58f1c0ddf92873ccca496faa1cf1753235cada"
        }
      },
      "source": {
        "provider": "wikimedia"
      },
      "license": {
        "status": "reviewed",
        "name": "Public domain"
      },
      "fetchedAt": "2026-07-28T16:07:34.487Z",
      "cachePolicy": {
        "mode": "vendored",
        "revalidateAfterDays": 30
      }
    },
    "KRX:012450": {
      "instrumentId": "KRX:012450",
      "ticker": "012450",
      "entityName": "Hanwha Aerospace Co., Ltd.",
      "relationship": "issuer",
      "relationshipNote": null,
      "providerSymbol": "File:Hanwha Aerospace Logo.svg",
      "asset": {
        "path": "/company-logos/KRX_012450.2f37f12bffa52abe.svg",
        "mimeType": "image/svg+xml",
        "byteSize": 6455,
        "hash": {
          "algorithm": "sha256",
          "value": "2f37f12bffa52abe03c9dc4ae4baa47eded954ebd1bba54d36604e5c1ffdcac5"
        }
      },
      "source": {
        "provider": "wikimedia"
      },
      "license": {
        "status": "reviewed",
        "name": "Public domain"
      },
      "fetchedAt": "2026-07-28T16:07:23.835Z",
      "cachePolicy": {
        "mode": "vendored",
        "revalidateAfterDays": 30
      }
    },
    "KRX:017670": {
      "instrumentId": "KRX:017670",
      "ticker": "017670",
      "entityName": "SK Telecom Co., Ltd.",
      "relationship": "issuer",
      "relationshipNote": null,
      "providerSymbol": "File:SK Telecom Logo.svg",
      "asset": {
        "path": "/company-logos/KRX_017670.f19a27c449753068.svg",
        "mimeType": "image/svg+xml",
        "byteSize": 101875,
        "hash": {
          "algorithm": "sha256",
          "value": "f19a27c449753068696f85f1e9f9a7ffdf826307377b26d468324513aeaab173"
        }
      },
      "source": {
        "provider": "wikimedia"
      },
      "license": {
        "status": "reviewed",
        "name": "Public domain"
      },
      "fetchedAt": "2026-07-28T16:24:16.416Z",
      "cachePolicy": {
        "mode": "vendored",
        "revalidateAfterDays": 30
      }
    },
    "KRX:018260": {
      "instrumentId": "KRX:018260",
      "ticker": "018260",
      "entityName": "Samsung SDS Co., Ltd.",
      "relationship": "issuer",
      "relationshipNote": null,
      "providerSymbol": "File:Samsung SDS logo.svg",
      "asset": {
        "path": "/company-logos/KRX_018260.7a961426bf477b64.svg",
        "mimeType": "image/svg+xml",
        "byteSize": 7584,
        "hash": {
          "algorithm": "sha256",
          "value": "7a961426bf477b64185a601b103da0ae6fbc9b9852620cad8320da39418e0c9f"
        }
      },
      "source": {
        "provider": "wikimedia"
      },
      "license": {
        "status": "reviewed",
        "name": "Public domain"
      },
      "fetchedAt": "2026-07-28T16:24:24.642Z",
      "cachePolicy": {
        "mode": "vendored",
        "revalidateAfterDays": 30
      }
    },
    "KRX:028260": {
      "instrumentId": "KRX:028260",
      "ticker": "028260",
      "entityName": "Samsung C&T Corporation",
      "relationship": "issuer",
      "relationshipNote": null,
      "providerSymbol": "File:Samsung C&T logo.svg",
      "asset": {
        "path": "/company-logos/KRX_028260.6bcb249f2915b9e0.svg",
        "mimeType": "image/svg+xml",
        "byteSize": 7034,
        "hash": {
          "algorithm": "sha256",
          "value": "6bcb249f2915b9e00162cce49d248dd2a1321489db26ed94af0d3b3f57ae07f6"
        }
      },
      "source": {
        "provider": "wikimedia"
      },
      "license": {
        "status": "reviewed",
        "name": "Public domain"
      },
      "fetchedAt": "2026-07-28T16:22:01.186Z",
      "cachePolicy": {
        "mode": "vendored",
        "revalidateAfterDays": 30
      }
    },
    "KRX:032830": {
      "instrumentId": "KRX:032830",
      "ticker": "032830",
      "entityName": "Samsung Life Insurance Co., Ltd.",
      "relationship": "issuer",
      "relationshipNote": null,
      "providerSymbol": "File:Samsung Life Insurance logo.svg",
      "asset": {
        "path": "/company-logos/KRX_032830.a3ddbe72bc0232c6.svg",
        "mimeType": "image/svg+xml",
        "byteSize": 10949,
        "hash": {
          "algorithm": "sha256",
          "value": "a3ddbe72bc0232c6e6a8125070005c3727bc053a9f87b2f7f8f0f2002a7266db"
        }
      },
      "source": {
        "provider": "wikimedia"
      },
      "license": {
        "status": "reviewed",
        "name": "Public domain"
      },
      "fetchedAt": "2026-07-28T16:22:09.400Z",
      "cachePolicy": {
        "mode": "vendored",
        "revalidateAfterDays": 30
      }
    },
    "KRX:033780": {
      "instrumentId": "KRX:033780",
      "ticker": "033780",
      "entityName": "KT&G Corporation",
      "relationship": "issuer",
      "relationshipNote": null,
      "providerSymbol": "File:KT&G Logo.svg",
      "asset": {
        "path": "/company-logos/KRX_033780.7935417479515f85.svg",
        "mimeType": "image/svg+xml",
        "byteSize": 7274,
        "hash": {
          "algorithm": "sha256",
          "value": "7935417479515f8523032d2418ebfa7d416044ddacfb8d57788e66522c110bc7"
        }
      },
      "source": {
        "provider": "wikimedia"
      },
      "license": {
        "status": "reviewed",
        "name": "Public domain"
      },
      "fetchedAt": "2026-07-28T16:22:25.491Z",
      "cachePolicy": {
        "mode": "vendored",
        "revalidateAfterDays": 30
      }
    },
    "KRX:034020": {
      "instrumentId": "KRX:034020",
      "ticker": "034020",
      "entityName": "Doosan Enerbility Co., Ltd.",
      "relationship": "issuer",
      "relationshipNote": null,
      "providerSymbol": "File:GihPdVB9-kBE3cimVn1szEsmR9aLEw2cHKk4dMMjBrFaT90CRUUUlvvahV18Ou-zKcRJD Lj Q5oNvqrLGOx3V7Jo1EnOqWCfC9HDZSyYF4G3eLiG4V0S3Nf p9fVvWCh0OtwNsSG0VMmBJSwYgFDg.webp",
      "asset": {
        "path": "/company-logos/KRX_034020.c18d8d7b56dc93ba.webp",
        "mimeType": "image/webp",
        "byteSize": 8846,
        "hash": {
          "algorithm": "sha256",
          "value": "c18d8d7b56dc93baf877f4721efe890c23c6371c52c6ee2d005222ef9ea3ceb9"
        }
      },
      "source": {
        "provider": "wikimedia"
      },
      "license": {
        "status": "reviewed",
        "name": "CC0"
      },
      "fetchedAt": "2026-07-28T16:24:32.619Z",
      "cachePolicy": {
        "mode": "vendored",
        "revalidateAfterDays": 30
      }
    },
    "KRX:034220": {
      "instrumentId": "KRX:034220",
      "ticker": "034220",
      "entityName": "LG Display Co., Ltd.",
      "relationship": "issuer",
      "relationshipNote": null,
      "providerSymbol": "File:LG Display logo (english).svg",
      "asset": {
        "path": "/company-logos/KRX_034220.fad31179963f8a13.svg",
        "mimeType": "image/svg+xml",
        "byteSize": 4227,
        "hash": {
          "algorithm": "sha256",
          "value": "fad31179963f8a13b2f52dfdeec9ccbe4e185a0d7cd3e7e634ef62f5a5730dbd"
        }
      },
      "source": {
        "provider": "wikimedia"
      },
      "license": {
        "status": "reviewed",
        "name": "Public domain"
      },
      "fetchedAt": "2026-07-28T16:24:08.407Z",
      "cachePolicy": {
        "mode": "vendored",
        "revalidateAfterDays": 30
      }
    },
    "KRX:036570": {
      "instrumentId": "KRX:036570",
      "ticker": "036570",
      "entityName": "NCSOFT Corporation",
      "relationship": "issuer",
      "relationshipNote": null,
      "providerSymbol": "File:NCSOFT logo.svg",
      "asset": {
        "path": "/company-logos/KRX_036570.97d0bb92130946f2.svg",
        "mimeType": "image/svg+xml",
        "byteSize": 1547,
        "hash": {
          "algorithm": "sha256",
          "value": "97d0bb92130946f299f3ee6c37e486225b36fbd04def8ee1757aa0070773ade4"
        }
      },
      "source": {
        "provider": "wikimedia"
      },
      "license": {
        "status": "reviewed",
        "name": "Public domain"
      },
      "fetchedAt": "2026-07-28T16:24:40.785Z",
      "cachePolicy": {
        "mode": "vendored",
        "revalidateAfterDays": 30
      }
    },
    "KRX:051910": {
      "instrumentId": "KRX:051910",
      "ticker": "051910",
      "entityName": "LG Chem, Ltd.",
      "relationship": "issuer",
      "relationshipNote": null,
      "providerSymbol": "File:LG Chem logo (english).svg",
      "asset": {
        "path": "/company-logos/KRX_051910.a00db1d1ae722adb.svg",
        "mimeType": "image/svg+xml",
        "byteSize": 3324,
        "hash": {
          "algorithm": "sha256",
          "value": "a00db1d1ae722adb57527f25ecdb60e149b210e7fbf9c7e780d6a36a0c9f9108"
        }
      },
      "source": {
        "provider": "wikimedia"
      },
      "license": {
        "status": "reviewed",
        "name": "Public domain"
      },
      "fetchedAt": "2026-07-28T16:22:17.582Z",
      "cachePolicy": {
        "mode": "vendored",
        "revalidateAfterDays": 30
      }
    },
    "KRX:068270": {
      "instrumentId": "KRX:068270",
      "ticker": "068270",
      "entityName": "Celltrion, Inc.",
      "relationship": "issuer",
      "relationshipNote": null,
      "providerSymbol": "File:Celltrion CI.svg",
      "asset": {
        "path": "/company-logos/KRX_068270.f4db87e2b3e1986b.svg",
        "mimeType": "image/svg+xml",
        "byteSize": 5054,
        "hash": {
          "algorithm": "sha256",
          "value": "f4db87e2b3e1986b3d4c0fbb611c6359c531f0e46f489932f8c4b4ae926000d8"
        }
      },
      "source": {
        "provider": "wikimedia"
      },
      "license": {
        "status": "reviewed",
        "name": "Public domain"
      },
      "fetchedAt": "2026-07-28T16:07:29.207Z",
      "cachePolicy": {
        "mode": "vendored",
        "revalidateAfterDays": 30
      }
    },
    "KRX:096770": {
      "instrumentId": "KRX:096770",
      "ticker": "096770",
      "entityName": "SK Innovation Co., Ltd.",
      "relationship": "issuer",
      "relationshipNote": null,
      "providerSymbol": "File:SK Innovation.svg",
      "asset": {
        "path": "/company-logos/KRX_096770.68a12206291f0543.svg",
        "mimeType": "image/svg+xml",
        "byteSize": 9627,
        "hash": {
          "algorithm": "sha256",
          "value": "68a12206291f0543ba368a2eb407e34ceaca481009a4fd734889c4c43bcb6dac"
        }
      },
      "source": {
        "provider": "wikimedia"
      },
      "license": {
        "status": "reviewed",
        "name": "Public domain"
      },
      "fetchedAt": "2026-07-28T16:22:49.245Z",
      "cachePolicy": {
        "mode": "vendored",
        "revalidateAfterDays": 30
      }
    },
    "KRX:105560": {
      "instrumentId": "KRX:105560",
      "ticker": "105560",
      "entityName": "KB Financial Group Inc.",
      "relationship": "issuer",
      "relationshipNote": null,
      "providerSymbol": "File:KB logo.svg",
      "asset": {
        "path": "/company-logos/KRX_105560.460821fd138b8651.svg",
        "mimeType": "image/svg+xml",
        "byteSize": 4827,
        "hash": {
          "algorithm": "sha256",
          "value": "460821fd138b8651115fb24a874fd7b32440210aa77bbb775a3861fee2a3ba23"
        }
      },
      "source": {
        "provider": "wikimedia"
      },
      "license": {
        "status": "reviewed",
        "name": "Public domain"
      },
      "fetchedAt": "2026-07-28T16:07:26.351Z",
      "cachePolicy": {
        "mode": "vendored",
        "revalidateAfterDays": 30
      }
    },
    "KRX:207940": {
      "instrumentId": "KRX:207940",
      "ticker": "207940",
      "entityName": "Samsung Biologics Co., Ltd.",
      "relationship": "issuer",
      "relationshipNote": null,
      "providerSymbol": "File:Samsung Biologics Logo.svg",
      "asset": {
        "path": "/company-logos/KRX_207940.e19a933f8680d209.svg",
        "mimeType": "image/svg+xml",
        "byteSize": 4869,
        "hash": {
          "algorithm": "sha256",
          "value": "e19a933f8680d209ca6347ba13e96d7d8e72bc18ad424d421156e84973709115"
        }
      },
      "source": {
        "provider": "wikimedia"
      },
      "license": {
        "status": "reviewed",
        "name": "Public domain"
      },
      "fetchedAt": "2026-07-28T16:07:01.271Z",
      "cachePolicy": {
        "mode": "vendored",
        "revalidateAfterDays": 30
      }
    },
    "KRX:329180": {
      "instrumentId": "KRX:329180",
      "ticker": "329180",
      "entityName": "HD Hyundai Heavy Industries Co., Ltd.",
      "relationship": "issuer",
      "relationshipNote": null,
      "providerSymbol": "File:Hyundai Heavy Industries logo (english).svg",
      "asset": {
        "path": "/company-logos/KRX_329180.74f0f81bc393a803.svg",
        "mimeType": "image/svg+xml",
        "byteSize": 3328,
        "hash": {
          "algorithm": "sha256",
          "value": "74f0f81bc393a8039a6bc94b7a32c0dc2dd7df1c67c9bcac48d8474d77a1b4bc"
        }
      },
      "source": {
        "provider": "wikimedia"
      },
      "license": {
        "status": "reviewed",
        "name": "Public domain"
      },
      "fetchedAt": "2026-07-28T16:07:32.009Z",
      "cachePolicy": {
        "mode": "vendored",
        "revalidateAfterDays": 30
      }
    },
    "KRX:373220": {
      "instrumentId": "KRX:373220",
      "ticker": "373220",
      "entityName": "LG Energy Solution, Ltd.",
      "relationship": "issuer",
      "relationshipNote": null,
      "providerSymbol": "File:LG Energy Solution logo EN.svg",
      "asset": {
        "path": "/company-logos/KRX_373220.f1e5afd09fe6ed4c.svg",
        "mimeType": "image/svg+xml",
        "byteSize": 6551,
        "hash": {
          "algorithm": "sha256",
          "value": "f1e5afd09fe6ed4cdbe9368895eac2002aad5b865ee6469c3f6d6304020570c8"
        }
      },
      "source": {
        "provider": "wikimedia"
      },
      "license": {
        "status": "reviewed",
        "name": "Public domain"
      },
      "fetchedAt": "2026-07-28T16:07:02.819Z",
      "cachePolicy": {
        "mode": "vendored",
        "revalidateAfterDays": 30
      }
    },
    "NASDAQ:AAPL": {
      "instrumentId": "NASDAQ:AAPL",
      "ticker": "AAPL",
      "entityName": "Apple Inc.",
      "relationship": "issuer",
      "relationshipNote": null,
      "providerSymbol": "File:Apple Logo.svg",
      "asset": {
        "path": "/company-logos/NASDAQ_AAPL.ec01134d849a9111.svg",
        "mimeType": "image/svg+xml",
        "byteSize": 1565,
        "hash": {
          "algorithm": "sha256",
          "value": "ec01134d849a9111a4bf78c634fc2329cf7495c5131b72e60e85b57822d3ad7c"
        }
      },
      "source": {
        "provider": "wikimedia"
      },
      "license": {
        "status": "reviewed",
        "name": "Public domain"
      },
      "fetchedAt": "2026-07-24T15:35:37.548Z",
      "cachePolicy": {
        "mode": "vendored",
        "revalidateAfterDays": 30
      }
    },
    "NASDAQ:MSFT": {
      "instrumentId": "NASDAQ:MSFT",
      "ticker": "MSFT",
      "entityName": "Microsoft Corporation",
      "relationship": "issuer",
      "relationshipNote": null,
      "providerSymbol": "File:Microsoft logo.svg",
      "asset": {
        "path": "/company-logos/NASDAQ_MSFT.3d41251f93127b4b.svg",
        "mimeType": "image/svg+xml",
        "byteSize": 272,
        "hash": {
          "algorithm": "sha256",
          "value": "3d41251f93127b4b42c2f69fa423d204946cf9c307d786ea36b8d9bef4179282"
        }
      },
      "source": {
        "provider": "wikimedia"
      },
      "license": {
        "status": "reviewed",
        "name": "Public domain"
      },
      "fetchedAt": "2026-07-24T15:35:38.286Z",
      "cachePolicy": {
        "mode": "vendored",
        "revalidateAfterDays": 30
      }
    },
    "NASDAQ:NVDA": {
      "instrumentId": "NASDAQ:NVDA",
      "ticker": "NVDA",
      "entityName": "NVIDIA Corporation",
      "relationship": "issuer",
      "relationshipNote": null,
      "providerSymbol": "File:Nvidia Logo.svg",
      "asset": {
        "path": "/company-logos/NASDAQ_NVDA.19b5df52a0a8606a.svg",
        "mimeType": "image/svg+xml",
        "byteSize": 4951,
        "hash": {
          "algorithm": "sha256",
          "value": "19b5df52a0a8606a699761c534d684486eae0dc265a35cac38e8b3beb0d621fd"
        }
      },
      "source": {
        "provider": "wikimedia"
      },
      "license": {
        "status": "reviewed",
        "name": "Apache License 2.0"
      },
      "fetchedAt": "2026-07-24T15:35:39.014Z",
      "cachePolicy": {
        "mode": "vendored",
        "revalidateAfterDays": 30
      }
    },
    "NASDAQ:TSLA": {
      "instrumentId": "NASDAQ:TSLA",
      "ticker": "TSLA",
      "entityName": "Tesla, Inc.",
      "relationship": "issuer",
      "relationshipNote": null,
      "providerSymbol": "File:Tesla Motors.svg",
      "asset": {
        "path": "/company-logos/NASDAQ_TSLA.63dffdd057fb53b0.svg",
        "mimeType": "image/svg+xml",
        "byteSize": 2521,
        "hash": {
          "algorithm": "sha256",
          "value": "63dffdd057fb53b00a6380476cff9bc424664b6eb3bbc82ef89f839f10717f6c"
        }
      },
      "source": {
        "provider": "wikimedia"
      },
      "license": {
        "status": "reviewed",
        "name": "Public domain"
      },
      "fetchedAt": "2026-07-24T15:35:39.739Z",
      "cachePolicy": {
        "mode": "vendored",
        "revalidateAfterDays": 30
      }
    },
    "NYSE:KO": {
      "instrumentId": "NYSE:KO",
      "ticker": "KO",
      "entityName": "The Coca-Cola Company",
      "relationship": "issuer",
      "relationshipNote": null,
      "providerSymbol": "File:Coca-Cola logo.svg",
      "asset": {
        "path": "/company-logos/NYSE_KO.4fc464932a70e200.svg",
        "mimeType": "image/svg+xml",
        "byteSize": 5169,
        "hash": {
          "algorithm": "sha256",
          "value": "4fc464932a70e200ec6e825228543a8b3d3d12f73be9e47caee1d9a421daf52d"
        }
      },
      "source": {
        "provider": "wikimedia"
      },
      "license": {
        "status": "reviewed",
        "name": "Public domain"
      },
      "fetchedAt": "2026-07-24T15:35:42.728Z",
      "cachePolicy": {
        "mode": "vendored",
        "revalidateAfterDays": 30
      }
    },
    "NYSEARCA:SPY": {
      "instrumentId": "NYSEARCA:SPY",
      "ticker": "SPY",
      "entityName": "State Street Global Advisors",
      "relationship": "fund-sponsor",
      "relationshipNote": "SPY ETF 자체 표식이 아니라 발행사 State Street의 브랜드 표식입니다.",
      "providerSymbol": "File:State-street-logo-final.svg",
      "asset": {
        "path": "/company-logos/NYSEARCA_SPY.535628a4bff400ac.svg",
        "mimeType": "image/svg+xml",
        "byteSize": 3327,
        "hash": {
          "algorithm": "sha256",
          "value": "535628a4bff400ac559a916e7d057e7023dd471725436ddfdceb17c652ee1f42"
        }
      },
      "source": {
        "provider": "wikimedia"
      },
      "license": {
        "status": "reviewed",
        "name": "Public domain"
      },
      "fetchedAt": "2026-07-24T15:35:45.683Z",
      "cachePolicy": {
        "mode": "vendored",
        "revalidateAfterDays": 30
      }
    }
  }
}
